export enum ElementType {
    LINK_TEXT = 'link text',
    CAROUSEL = 'carousel',
    BANNER = 'banner',
    TAB = 'tab',
    ORG_PICKER_BADGE = 'Org Picker - Badge',
    ORG_PICKER_DROPDOWN = 'Org Picker - Dropdown',
    ORG_PICKER_SWITCH_ORG = 'Org Picker - Switch Org',
    ORG_PICKER_SWITCH_SUCCESS = 'Org Picker - Switch Success',
    ORG_PICKER_DISMISS = 'Org Picker - Dismiss',
    ORG_PICKER_NO_RESULTS = 'Org Picker - No Results',
    ORG_PICKER_SEARCH_USED = 'Org Picker - Search Used',
    ORG_PICKER_FILTER_USED = 'Org Picker - Filter Used',
    ORG_PICKER_ERROR = 'Org Picker - Error',
}

export enum ElementTitle {
    SUPPORT_LEGAL = 'support:legal',
    SUPPORT_CONTACT = 'support:contact',
    OVERVIEW = 'overview',
    WATCH_DEMO = 'watch demo',
}

export const LISTING_DETAIL_TAB_TITLES: Record<string, string> = {
    'overview-tab': 'overview',
    'specs-tab': 'specs',
    'security-tab': 'security',
    'reviews-tab': 'reviews',
    'pricing-tab': 'pricing',
    'resources-tab': 'resources',
    'support-tab': 'support',
    'agentforceContent-tab': 'agentforce content',
    'competencies-tab': 'competencies',
    competencies_industry_tab: 'competencies',
    competencies_product_tab: 'competencies',
    'moreDetails-tab': 'more details',
    'packageFiles-tab': 'files',
    'found-in-tab': 'found in',
};
